import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { multilanguage } from "redux-multilanguage";
import {
    globalURL
} from "../../../constants";
import { connect } from "react-redux";
import {
    removeFromShoppingCart
} from "../../../../redux/actions/shoppingCartActions";

const MenuCart = ({ shoppingCart, removeFromShoppingCart, strings, currentLanguageCode, login }) => {
    const { addToast } = useToasts();

    return (
        <div className="shopping-cart-content">
            <button style={{ position: "absolute", top: 10, right: 10 }} onClick={e => {
                const offcanvasMobileMenu = document.querySelector(
                    "button.icon-cart"
                );

                offcanvasMobileMenu.nextSibling.classList.toggle("active");
            }}>
                <i className="fa fa-times-circle" />
            </button>

            {shoppingCart.data.length > 0 ? (
                <Fragment>
                    <ul style={{ marginTop: 33 }}>
                        {shoppingCart.data.map((single, key) => {
                            return (
                                <li className="single-shopping-cart" key={key}>
                                    <div className="shopping-cart-img">
                                        <Link to={process.env.PUBLIC_URL + "/product/" + single.product.seoName + "/" + single.detail.color.colorCode}>
                                            <img
                                                alt={single.product.seoName}
                                                src={globalURL + "/images/" + single.images[0].name}
                                                className="img-fluid"
                                            />
                                        </Link>
                                    </div>
                                    <div className="shopping-cart-title">

                                        <Link
                                            to={process.env.PUBLIC_URL + "/product/" + single.product.seoName + "/" + single.detail.color.colorCode}
                                        >
                                            {" "}
                                            {single.product.productName[currentLanguageCode]}{" "}
                                        </Link>

                                        <h6>{strings['menuCart']['quantity']}: {single.quantity}</h6>
                                        <span>
                                            {single.product.hasDiscount === true ?
                                                <Fragment>
                                                    <span>
                                                        {single.product.discountedPrice.try}{" "}{single.product.discountedPrice.try ? "TL" : ""}
                                                    </span>{" "}
                                                    <span style={{ textDecorationLine: "line-through" }}>
                                                        {single.product.normalPrice.try}{" "}{single.product.normalPrice.try ? "TL" : ""}
                                                    </span>
                                                </Fragment> : <span>
                                                    {single.product.normalPrice.try}{" "}{single.product.normalPrice.try ? "TL" : ""}
                                                </span>
                                            }
                                        </span>
                                        <div className="cart-item-variation">
                                            <span>{strings['menuCart']['color']}: {single.detail.color.colorName}</span>
                                            <span>{strings['menuCart']['size']}: {single.detail.size.sizeCode}</span>
                                        </div>
                                    </div>
                                    <div className="shopping-cart-delete">
                                        <button onClick={() => removeFromShoppingCart(login.user.token, single.stockCard, key, addToast, strings)}>
                                            <i className="fa fa-times" />
                                        </button>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                    <div className="shopping-cart-total">
                        <h4>
                            {strings['cartPage']['cart']['totalProducts']}
                            <span className="shop-total">
                                {shoppingCart.totalPrice}{" "}{"TL"}
                            </span><br />
                            {
                                shoppingCart.shippingPrice > 0 ?
                                    <>
                                        {strings['checkoutPage']['yourOrder']['shipping']}
                                        <span className="shop-total">
                                            {shoppingCart.shippingPrice}{" "}{"TL"}
                                        </span><br />
                                    </> : null
                            }
                            {strings['cartPage']['cart']['discountPrice']}
                            <span className="shop-total">
                                {shoppingCart.discount > 0 ? "-" : ""}{shoppingCart.discount}{" "}{"TL"}
                            </span><br />
                            {strings['cartPage']['cart']['grandTotal']}
                            <span className="shop-total">
                                {shoppingCart.lastPrice}{" "}{"TL"}
                            </span>
                        </h4>

                    </div>
                    <div className="shopping-cart-btn btn-hover text-center">
                        <div className="row">
                            <div className="col-md-6">
                                <Link className="default-btn" to={process.env.PUBLIC_URL + "/cart"}>
                                    {strings['menuCart']['viewCart']}
                                </Link>
                            </div>
                            <div className="col-md-6">
                                <Link
                                    className="default-btn"
                                    to={process.env.PUBLIC_URL + "/checkout"}
                                >
                                    {strings['menuCart']['checkout']}
                                </Link>
                            </div>
                        </div>
                    </div>
                </Fragment>
            ) : (
                <p className="text-center">{strings['menuCart']['noItems']}</p>
            )}
        </div>
    );
};

MenuCart.propTypes = {
    cartData: PropTypes.array,
    currency: PropTypes.object,
    deleteFromCart: PropTypes.func
};


const mapStateToProps = state => {
    return {
        shoppingCart: state.shoppingCart,
        login: state.login
    };
};


export default connect(mapStateToProps, {
    removeFromShoppingCart
})(multilanguage(MenuCart));